const initEventTableBlocks = () => {
	const contentTableSections = document.querySelectorAll('.block-events-table');

	if ( contentTableSections.length ) {
		contentTableSections.forEach( block => {
			initEventTableBlock(block);
		})
	}
}

const initEventTableBlock = ( block) => {
	const loadMoreButtonWrapper = block.querySelector('.load-more-button-wrapper');
	const loadMoreButton = block.querySelector('.load-more-button-wrapper .btn-load-more');
	const rows = block.querySelectorAll('.block-events-table table tbody tr');
	const data = {
		block,
		loadMoreButtonWrapper,
		rows,
		rowsToShow: 10,
		currentPage: 1,
		totalPages: Math.ceil(rows.length / 10)
	}

	if(rows.length > data.rowsToShow) {
		for (let i = data.rowsToShow; i < rows.length; i++) {
			rows[i].classList.add('hidden');
		}
		loadMoreButtonWrapper.classList.add('active');
	}

	if (loadMoreButton && loadMoreButtonWrapper.classList.contains('active')) {
		loadMoreButton.addEventListener('click', (e) => {
			loadMoreTableRows(e, data);
		});
	}
}

const loadMoreTableRows = (e, data) => {
	e.preventDefault();

	if ( data.currentPage >= data.totalPages ) return;

	for (let i = data.currentPage * data.rowsToShow; i < (data.currentPage + 1) * data.rowsToShow; i++) {
		data.rows[i]?.classList.remove('hidden');
	}

	data.currentPage++;

	if ( data.currentPage >= data.totalPages ) {
		data.loadMoreButtonWrapper.classList.remove('active');
	}
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		initEventTableBlocks();
	},
	loaded() {},	
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller; 
